import { render, staticRenderFns } from "./PtrSearch.vue?vue&type=template&id=5104ef00&scoped=true"
import script from "./PtrSearch.vue?vue&type=script&lang=js"
export * from "./PtrSearch.vue?vue&type=script&lang=js"
import style0 from "./PtrSearch.vue?vue&type=style&index=0&id=5104ef00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104ef00",
  null
  
)

export default component.exports